module.exports = new __parcel__URL__("grand-theft-auto-iv.90c33c3d.jpg").toString();